import { getRequest, postRequest } from "@/lib/api";

export type UserRole = "BUYER" | "BREEDER" | "ADMIN";
export type AuthUser = { userId: string; name: string; roles: UserRole[] };
export type AuthResponse = { user: AuthUser };

function saveSession(response: AuthResponse) {
  window.dispatchEvent(new Event("ondog-auth-change"));
  return response;
}

export const login = async (userId: string, password: string) =>
  saveSession(
    await postRequest<AuthResponse, object>("auth/login", { userId, password }),
  );
export type SignupInput = {
  userId: string;
  password: string;
  name: string;
  email: string;
  phone: string;
  birthDate: string;
  identityVerificationId: string;
  termsVersion: string;
  privacyVersion: string;
  requiredTermsAgreed: true;
  marketingConsent: boolean;
};
export type IdentityVerification = {
  id: string;
  status: "PENDING" | "VERIFIED" | "CONSUMED";
  name?: string;
  birthDate?: string;
  phone?: string;
  expiresAt: string;
  provider: "KCP" | "MOCK";
  developmentMock?: boolean;
  callUrl?: string;
  form?: { reg_cert_key: string; kcp_page_submit_yn: "Y" | "N" };
  pollToken?: string;
};
export const requestPhoneVerification = (
  identity: Pick<SignupInput, "name" | "birthDate" | "phone">,
) =>
  postRequest<IdentityVerification, typeof identity>(
    "auth/phone-verifications",
    identity,
  );
export const getPhoneVerification = (id: string, pollToken: string) =>
  getRequest<IdentityVerification>(`auth/phone-verifications/${id}`, {
    pollToken,
  });
export const signup = async (input: SignupInput) =>
  saveSession(
    await postRequest<AuthResponse, SignupInput>("auth/signup", input),
  );
export const getMe = () => getRequest<AuthUser>("auth/me");
export const getOptionalMe = () => getRequest<AuthUser | null>("auth/session");
export const logout = async () => {
  try {
    await postRequest<{ success: boolean }, object>("auth/logout", {});
  } finally {
    window.dispatchEvent(new Event("ondog-auth-change"));
  }
};
